// TODO: Rewrite to use spicecomponents
import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const Select = styled.select`
  border-radius: 0 !important;
  border: 0 !important;
  background-color: #e8e8e8 !important;
  border: 1px solid #ccc;
  min-height: 400px;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
  padding: 6px 12px;
  margin-bottom: 0;
  option[disabled]{
    cursor: not-allowed;
    color: #b7b7b7;
  }
`;

const Div = styled.div`
  margin-bottom: 30px;
`;

/*
 * MultipleAnswers
 *
 * Renders a multi-select box with two types of options - Answers and Nets, passed in via the
 * controlList. Additional logic is included for cleaning up the data to be passed back to the
 * CDF, and also some NET options are exclusive, so selecting them will disable the corresponding
 * the Answer options.
 */
const AnswersToShow = (props) => {
  const getOptions = (options, cdfAnswers) => {
    let cdfNets = cdfAnswers ? cdfAnswers.filter((v) => v.Net !== undefined) : [];
    cdfNets = cdfNets.map((v) => {
      const label = Object.values(v)[0];
      return getNetValuesFromName(label, props.controlList.AnswersToShow.Options.Nets);
    });
    const answers = options.Answers.map((a) => {
      const value = Object.keys(a)[0];
      const text = a[value];
      let disabled = false;
      if (cdfNets.length > 0) {
        const numVal = parseFloat(value);
        disabled = [].concat(...cdfNets).indexOf(numVal) !== -1;
      }
      return { text, value, type: 'Value', disabled };
    });
    const nets = options.Nets.map((n) => {
      const key = Object.keys(n)[0];
      const text = `NET: ${key}`;
      const value = n[key];
      return { text, value: JSON.stringify(value), type: 'Net', netLabel: key };
    });
    return answers.concat(nets);
  };

  const getNetValuesFromName = (netName, netOptions) => netOptions.filter((v) => v[netName] !== undefined).map((v) => Object.values(v))[0][0];

  const onChange = (e) => {
    const selected = Array.from(e.target.selectedOptions);

    const answers = selected.filter((o) => o.dataset.type === 'Value');
    const nets = selected.filter((o) => o.dataset.type === 'Net');

    for (let x = 0; x < nets.length; x++) {
      const net = nets[x];
      const netAnswerValues = JSON.parse(net.value);
      for (let x = 0; x < netAnswerValues.length; x++) {
        const options = answers.filter((v) => parseFloat(v.value) === netAnswerValues[x]);
        for (let x = 0; x < options.length; x++) {
          options[x].selected = false;
        }
      }
    }

    const cdfValue = Array.from(e.target.selectedOptions).map((v) => {
      const obj = {};
      if (v.dataset.type === 'Value')obj[v.dataset.type] = v.value;
      else obj[v.dataset.type] = v.dataset.netLabel;
      return obj;
    });

    if (cdfValue.length > 0) {
      props.updateCDF('AnswersToShow', cdfValue);
    } else {
      props.updateCDF('AnswersToShow', null);
    }
  };

  const getValueFromProps = () => ((answers) => {
    if (answers && answers.length > 0) {
      return answers.map((v) => {
        const key = Object.keys(v)[0];
        if (key === 'Value') {
          return v[key];
        }
        return JSON.stringify(getNetValuesFromName(v[key], props.controlList.AnswersToShow.Options.Nets));
      });
    }
    return [];
  })(props.cdf.AnswersToShow);

  const controlList = props.controlList;
  const options = getOptions(controlList.AnswersToShow.Options, props.cdf.AnswersToShow).map((o) => (
    <option key={o.value} value={o.value} data-type={o.type} data-net-label={o.netLabel || null} disabled={o.disabled || false}>{o.text}</option>
  ));
  return (
    <Div>
      <label htmlFor="answersToShow">Options</label>
      <Select name="answersToShow" multiple value={getValueFromProps()} onChange={onChange}>
        {options}
      </Select>
      <p className="help-block"><i className="glyphicon glyphicon-info-sign"></i> CTRL/CMD + click to deselect</p>
    </Div>
  );
};

AnswersToShow.propTypes = {
  cdf: PropTypes.object,
  controlList: PropTypes.object,
};

export default AnswersToShow;



// WEBPACK FOOTER //
// ./app/components/FormControls/AnswersToShow/MultipleAnswers.js